export default __webpack_public_path__ + "static/media/purple_flowers.809d13dd.png";